<template>
  <div>
    <v-row class="d-flex justify-center">
      <v-col cols="auto" class="pr-3 text-center">
        <QuotationStatusMessage
          title="Para visualizar as propostas da sua cotação é necessário que efetue o login no sistema"
          text=""
        />
      </v-col>
      <v-col cols="3" class="text-center userEmail">
        <LoginForm :userEmail="this.userEmail" />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import LoginForm from "../../auth/components/LoginForm.vue";
import QuotationStatusMessage from "../components_agro/QuotationStatusMessage";

export default {
  components: {
    QuotationStatusMessage,
    LoginForm
  },
  props: {
    userEmail: {
      type: String
    }
  }
};
</script>
<style scoped>
.userEmail {
  margin-top: -40px;
}
</style>
